<ng-template #dragDotsTpl>
    @for (dot of dragDots; track dot) {
        <span class="sh-facet-list__drag-handle__dot"></span>
    }
</ng-template>

<ng-template #facetTpl let-facet let-pinned="pinned">
    <sh-facet
        [facet]="facet"
        [showMoreMsg]="showMoreMsg"
        [blockShowMore]="blockShowMore"
        [collapsible]="collapsible && !pinned"
        [expanded]="isExpanded(facet)"
        [bodyTemplate]="bodyTemplateFor(facet)"
        (loadMore)="onLoadMore($event)"
        (valueSelected)="onValueSelected($event)"
        (selectionChanged)="onSelectionChange($event)"
        (expandedToggled)="onExpandToggle(facet)"
    ></sh-facet>
</ng-template>

@if (reorderable) {
    <div class="sh-facet-list sh-facet-list--reorderable" [class.sh-facet-list--compact]="collapsible" cdkDropList (cdkDropListDropped)="onDrop($event)">
        @for (facet of pinnedFacets; track facet.key) {
            <div class="sh-facet-list__item">
                <span class="sh-facet-list__drag-handle sh-facet-list__drag-handle--pinned" aria-hidden="true">
                    <ng-container [ngTemplateOutlet]="dragDotsTpl"></ng-container>
                </span>
                <ng-container [ngTemplateOutlet]="facetTpl" [ngTemplateOutletContext]="{ $implicit: facet, pinned: true }"></ng-container>
            </div>
        }
        @for (facet of draggableFacets; track facet.key) {
            <div class="sh-facet-list__item" cdkDrag>
                <button type="button" class="sh-facet-list__drag-handle" cdkDragHandle [attr.aria-label]="'facets.reorder-handle' | translate">
                    <ng-container [ngTemplateOutlet]="dragDotsTpl"></ng-container>
                </button>
                <ng-container [ngTemplateOutlet]="facetTpl" [ngTemplateOutletContext]="{ $implicit: facet }"></ng-container>
            </div>
        }
    </div>
} @else {
    <div class="sh-facet-list" [class.sh-facet-list--compact]="collapsible">
        @for (facet of pinnedFacets; track facet.key) {
            <ng-container [ngTemplateOutlet]="facetTpl" [ngTemplateOutletContext]="{ $implicit: facet, pinned: true }"></ng-container>
        }
        @for (facet of draggableFacets; track facet.key) {
            <ng-container [ngTemplateOutlet]="facetTpl" [ngTemplateOutletContext]="{ $implicit: facet }"></ng-container>
        }
    </div>
}
